import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  imports: [],
  templateUrl: './loading-spinner.html',
  styleUrl: './loading-spinner.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinner {
  size = input<'button' | 'small' | 'normal' | 'large'>('normal');
  color = input<string>('border-yellow-500');
  type = input<'default' | 'dots'>('default');

  protected readonly sizeClasses = computed(() => {
    switch (this.size()) {
      case 'button':
        return 'w-5 h-5 mr-2';
      case 'small':
        return 'w-5 h-5';
      case 'large':
        return 'w-16 h-16';
      default:
        return 'w-10 h-10';
    }
  });

  protected readonly dotSizeClasses = computed(() => {
    switch (this.size()) {
      case 'button':
        return 'w-1.5 h-1.5';
      case 'small':
        return 'w-2 h-2';
      case 'large':
        return 'w-4 h-4';
      default:
        return 'w-3 h-3';
    }
  });
}
